<ng-container>
    <div>
        <div>
            <!-- grid start -->
            <table tsl-table [dataSource]="currentPageSource" displayStripes="false">
                <!-- <ng-container tslColumnDef="purpose">
                    <th tsl-header-cell *tslHeaderCellDef class="columnwidth" i18n> Purpose </th>
                    <td tsl-cell *tslCellDef="let type">
                    </td>
                </ng-container> -->
                <ng-container tslColumnDef="address">
                    <th tsl-header-cell *tslHeaderCellDef class="columnwidth" i18n="@@e9ded9ddc67d3d863a5484c81550ee0de9b0ff04" t="e9ded9ddc67d3d863a5484c81550ee0de9b0ff04"> Address </th>
                    <td tsl-cell *tslCellDef="let element">
                        <div class="address"
                            *ngIf="element.locationName || getFullAddress(element) || getFullAddressDetails(element) || getCountryDetails(element); else empty">

                            <span class="address_title"><b>{{element.locationName}}</b></span><br>
                            <span class="address_details">
                                {{getFullAddress(element)}}<br>
                                {{getFullAddressDetails(element)}}<br>
                                {{getCountryDetails(element)}}
                            </span>

                        </div>
                    </td>
                </ng-container>

                <ng-container tslColumnDef="comment">
                    <th tsl-header-cell *tslHeaderCellDef class="comments" i18n="@@a3d57cb09b8c89d3e10ceaf70f53ad0d454144ee" t="a3d57cb09b8c89d3e10ceaf70f53ad0d454144ee">Comment</th>
                    <td tsl-cell *tslCellDef="let element">
                        <div *ngIf="element.comment.newValue; else empty">{{ element.comment.newValue }} </div>
                    </td>
                </ng-container>

                <ng-container tslColumnDef="documents">
                    <th tsl-header-cell *tslHeaderCellDef class="documents" i18n="@@627a946d2acf02d81b1a7edcacd987bb8e8d1814" t="627a946d2acf02d81b1a7edcacd987bb8e8d1814">Documents</th>
                    <td tsl-cell *tslCellDef="let element">
                        <div>
                            
                        </div>
                    </td>
                </ng-container>
                <ng-container tslColumnDef="contacts">
                    <th tsl-header-cell *tslHeaderCellDef class="contacts" i18n="@@Contacts" t="Contacts">Contacts</th>
                    <td tsl-cell *tslCellDef="let element">
                        <!-- {{element | json}} -->
                            <div *ngFor="let contact of element.contacts?.newValue">
                            <ng-container *ngIf="contact">
                               <div style="margin: 2px 0px 5px 0px;">
                                  <tsl-chip>
                                   <div *ngIf="contact?.name" style="width:300px;max-width:300px;word-wrap: break-word; margin: 0px 0px 2px 0px;">{{contact?.name}},</div>
                                   <div *ngIf="contact?.phone" style="width:300px;max-width:300px;word-wrap: break-word;margin: 0px 0px 2px 0px;">{{contact?.phone}},</div>
                                   <div *ngIf="contact?.email" style="width:300px;max-width:300px;word-wrap: break-word;margin: 0px 0px 2px 0px;">{{contact?.email}} <tsl-icon *ngIf="this.checkIfContactAlreadyExists(contact?.email)" size="small" class="header-help-icon" i18n-title title="This is an existing contact in your organizations Profile Contact Tab.">info</tsl-icon></div>
                                  </tsl-chip>
                                </div>
                            </ng-container>
                            </div>
                     </td>
                </ng-container>

                <ng-container tslColumnDef="actions">
                    <th tsl-header-cell *tslHeaderCellDef class="actions icons" i18n="@@030b4423b92167200e39519599f9b863b4f7c62c" t="030b4423b92167200e39519599f9b863b4f7c62c">Actions</th>
                    <td tsl-cell *tslCellDef="let element" class="actions icons" >
                        <ng-container>
                            <span style="display: flex;" *ngIf="showLinkDelink && preventativeHold==false">
                                <button tsl-button color="black" filled size="small" (click)="openLinkDialog(element)" i18n-title title="This action will link a contact to a specific Ship From location." outline>Link Contact</button>
                                <button tsl-button color="black" filled size="small" (click)="openUnlinkDialog(element)" i18n-title title="This action will delink a contact from a specific Ship From location." outline>Delink Contact</button>
                            </span>
                        </ng-container>

                    </td>
                </ng-container>

                <tr tsl-header-row *tslHeaderRowDef="displayedColumns"></tr>
                <tr tsl-row *tslRowDef="let row; columns: displayedColumns;"></tr>
            </table>
            <!-- grid end -->
            <ng-template #empty>
                <tsl-icon>maximize</tsl-icon>
            </ng-template>
            <!-- grid pagination -->
            <tsl-pagination showFirstLastButtons [pageSizeOptions]="pageSizeOptions" showFirstLastButtons
                (pageChange)="pageChange($event)" [itemsPerPageLabel]="translateService.get('ItemsPerPage')" [total]="total"></tsl-pagination>
        </div>

        
    </div>
</ng-container>